export default __webpack_public_path__ + "static/media/logo2.c78ebab4.png";